var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 12.5H2.8125C2.63991 12.5 2.5 12.6399 2.5 12.8125V18.4375C2.5 18.6101 2.63991 18.75 2.8125 18.75H4.0625C4.23509 18.75 4.375 18.6101 4.375 18.4375V12.8125C4.375 12.6399 4.23509 12.5 4.0625 12.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 8.75H11.5625C11.3899 8.75 11.25 8.88991 11.25 9.0625V18.4375C11.25 18.6101 11.3899 18.75 11.5625 18.75H12.8125C12.9851 18.75 13.125 18.6101 13.125 18.4375V9.0625C13.125 8.88991 12.9851 8.75 12.8125 8.75Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 4.375H15.9375C15.7649 4.375 15.625 4.51491 15.625 4.6875V18.4375C15.625 18.6101 15.7649 18.75 15.9375 18.75H17.1875C17.3601 18.75 17.5 18.6101 17.5 18.4375V4.6875C17.5 4.51491 17.3601 4.375 17.1875 4.375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 1.25H7.1875C7.01491 1.25 6.875 1.38991 6.875 1.5625V18.4375C6.875 18.6101 7.01491 18.75 7.1875 18.75H8.4375C8.61009 18.75 8.75 18.6101 8.75 18.4375V1.5625C8.75 1.38991 8.61009 1.25 8.4375 1.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataWhite);
export default __webpack_public_path__ + "static/media/dataWhite.dc23c6fdd391ef9eb3e741a3fb70e57b.svg";
export { ForwardRef as ReactComponent };